module.exports = __webpack_public_path__ + "img/VL_18_01.d0a142fc.png";